export const paginationState = {
  page: 1,
  pageSize: 10,
  count: 0,
};

export const paginationActions = {
  setPageSize({ commit, dispatch }, size) {
    commit('setPage', 1);
    commit('setPageSize', size);
    dispatch('fetchItems');
  },
};

export const paginationMutations = {
  setPage(state, page) {
    state.page = page;
  },
  setPageSize(state, size) {
    state.pageSize = size;
  },
  setCount(state, count) {
    state.count = count;
  },
};

export const paginationGetters = {
  page: (state) => state.page,
  pageSize: (state) => state.pageSize,
  count: (state) => state.count,

};
